import React, { useCallback, useEffect, useState } from "react";
import Loader from "../../Loader/Loader";
import { getJoinUsAPI } from "../../utils/APIs/joinUsApis";
import JoinUsTable from "./JoinUsTable/JoinUsTable";

const JoinUs = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [joinUsData, setJoinUsData] = useState([]);

  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem("joinUsPage");
    return savedPage ? Number(savedPage) : 1;
  });

  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const LIMIT = 10;

  useEffect(() => {
    const interval = setInterval(() => {
      const stored = sessionStorage.getItem("isSidebarOpen");
      const parsed = stored !== null ? JSON.parse(stored) : true;

      if (parsed !== isSidebarOpen) {
        setIsSidebarOpen(parsed);
      }
    }, 10);

    return () => clearInterval(interval);
  }, [isSidebarOpen]);

  const fetchData = useCallback(async (pageNo = page) => {
    setLoading(true);
    try {
      const res = await getJoinUsAPI(pageNo, LIMIT);

      setJoinUsData(res?.data?.data || []);
      setTotal(res?.data?.pagination?.totalRecords || 0);
      setPage(res?.data?.pagination?.currentPage || pageNo);

      sessionStorage.setItem(
        "joinUsPage",
        res?.data?.pagination?.currentPage || pageNo
      );
    } catch (err) {
      console.error("failed to fetch join us data", err);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchData(page);
  }, [fetchData, page]);

  const totalPages = Math.ceil(total / LIMIT);

   const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 3; // how many numbers you want visible
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, page + 2);

    if (end - start < maxVisible - 1) {
      if (start === 1) {
        end = Math.min(totalPages, start + maxVisible - 1);
      } else if (end === totalPages) {
        start = Math.max(1, end - maxVisible + 1);
      }
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  if (loading) return <Loader />;

  return (
    <div
      className={`content-container ${
        isSidebarOpen ? "sidebar-open" : "sidebar-closed"
      }`}
      style={{ marginTop: "100px" }}
    >
      <div className="page-inner-wrapper">
        <h2 className="page-title">Join Us</h2>

        <JoinUsTable
          data={joinUsData}
          page={page}
          limit={LIMIT}
        />

          {total > LIMIT && (
        <div className="pagination">
          {/* Prev */}
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          {/* Page Numbers */}
          {getPageNumbers().map((p) => (
            <button
              key={p}
              className={`pagination-btn ${p === page ? "active" : ""}`}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          ))}

          {/* Next */}
          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
      </div>
    </div>
  );
};

export default JoinUs;